import angular from "angular";

angular
    .module('app')
    .component('moduleForm', {
        template: require('./module-form.html'),
        controller: ['$http', 'ErrorResponseParser', 'Notifier', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($http, ErrorResponseParser, Notifier) {

    let $ctrl = this;

    $ctrl.id = null;
    $ctrl.name = null;
    $ctrl.label = null;
    $ctrl.type = null;

    $ctrl.$onInit = function () {
        if ($ctrl.resolve.module) {
            $ctrl.id = $ctrl.resolve.module.id;
            $ctrl.name = $ctrl.resolve.module.name;
            $ctrl.label = $ctrl.resolve.module.label;
            $ctrl.type = $ctrl.resolve.module.type;
        }
    };

    $ctrl.submit = function () {

        let req = null;
        $ctrl.loading = true;

        let params = {
            name: $ctrl.name,
            label: $ctrl.label,
            type: $ctrl.type,
        };


        if ($ctrl.id) {
            params['_method'] = 'PUT';
            req = $http.post(`/admin/modules/${$ctrl.id}`, params);


        } else {
            req = $http.post('/admin/modules', params);
        }

        req.then(
            function (response) {
                if (!$ctrl.id) {
                    $ctrl.id = response.data.id;
                    Notifier.success('Модуль успешно создан', 2);
                } else {
                    Notifier.success('Модуль успешно обновлен', 2);
                }
                $ctrl.loading = false;
                $ctrl.close({$value: {id: $ctrl.id, name: $ctrl.name, label: $ctrl.label, type: $ctrl.type}});
            },
            function (error) {

                $ctrl.loading = false;
                ErrorResponseParser.parse(error);
            }
        );
    };

}
